import React, { useState, useEffect, useRef } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import girlimg from "assets/img/girlimg.png";
import zigzag from "assets/img/zigzag.webp";
import school from "assets/img/new/way/school.webp";
import one from "assets/img/new/way/one.webp";
import two from "assets/img/new/way/two.webp";
import three from "assets/img/new/way/three.webp";
import four from "assets/img/new/way/four.webp";
import five from "assets/img/new/way/five.webp";
import bgg from "assets/img/bgg.png";
import bfly1 from "assets/img/bfly1.webp";
import clouds from "assets/img/clouds.webp";
import emailjs from "@emailjs/browser";
import axios from "axios";
import toast from "react-hot-toast";
import ReCAPTCHA from "react-google-recaptcha";

export default function HowToApply() {
  const form = useRef(null);
  const [formStatus, setFormStatus] = useState("idle");
  const [captchaToken, setCaptchaToken] = useState(null);

  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm("service_icbt4b6", "template_00dulvn", form.current, {
  //       publicKey: "k2xgdVDnjkIFOHFOR",
  //     })
  //     .then(
  //       () => {
  //         console.log("SUCCESS!");
  //         setFormStatus("success");
  //         // Reset the form
  //         if (form.current) {
  //           form.current.reset();
  //         }
  //         // Redirect to /thankyoupage
  //         window.location.href = "/admission-thank-you";
  //       },
  //       (error) => {
  //         console.log("FAILED...", error.text);
  //         setFormStatus("error");
  //         // Reset form status after a short delay
  //         setTimeout(() => {
  //           setFormStatus("idle");
  //         }, 1000);
  //       }
  //     );
  // };

  const sendEmail = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const data = {
      fullname: formData.get("name")?.trim(),
      parentname: formData.get("parentname")?.trim(),
      branch: formData.get("branch"),
      program: formData.get("program"),
      email: formData.get("email")?.trim(),
      phone: formData.get("tel")?.trim(),
      captcha: captchaToken,
    };

    // Validation checks
    if (!data.fullname || data.fullname.length < 3) {
      toast.error("Full Name must be at least 3 characters long");
      return;
    }
    if (!data.parentname || data.parentname.length < 3) {
      toast.error("Parent Name must be at least 3 characters long");
      return;
    }
    if (!data.phone) {
      toast.error("Phone number is required");
      return;
    }
    if (!/^\d{10}$/.test(data.phone)) {
      toast.error("Enter a valid 10-digit phone number");
      return;
    }
    if (!data.email) {
      toast.error("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      toast.error("Enter a valid email address");
      return;
    }
    if (!data.branch) {
      toast.error("Please select a Branch");
      return;
    }
    if (!data.program) {
      toast.error("Please select a Program");
      return;
    }
    if (!captchaToken) {
      toast.error("Please verify you're not a robot");
      return;
    }

    try {
      const response = await axios.post(
        "https://api.juniortoes.com/api/admissions",
        data,
      );

      if (response.status === 200) {
        toast.success("Form submitted successfully!");
        window.location.href = "/admission-thank-you";
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  // State for tracking the active step
  const [activeStep, setActiveStep] = useState("step1");

  const handleScroll = () => {
    const sections = [
      "content1",
      "content2",
      "content3",
      "content4",
      "content5",
      "content6",
    ];
    sections.forEach((section, index) => {
      const element = document.getElementById(section);
      if (element) {
        const rect = element.getBoundingClientRect();
        // Check if the section is in the viewport
        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom >= window.innerHeight / 2
        ) {
          setActiveStep(`step${index + 1}`);
        }
      }
    });
  };

  // Ensure the active step is set when the component is first loaded
  useEffect(() => {
    // Call the scroll handler once on load to highlight the section in view
    handleScroll();

    // Adding event listener for scroll when component mounts
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array to run once on mount

  return (
    <>
      <AdminNavbar fixed />
      <div className="parkinsans">
        <section
          className=" xl:pt-28 lg:pt-28 md:pt-24 xl:pb-16 lg:pb-16 md:pb-16 parkinsans pb-12 xl:block lg:block md:block sm:block block"
          style={{
            backgroundColor: "#f0f7fa",
            backgroundImage: `url(${bgg})`,
            backgroundPosition: "center center",
            backgroundRepeat: "repeat",
            backgroundSize: "55% auto",
          }}
        >
          <div className=" container mx-auto gap-6 xl:px-0 px-4">
            <div className=" flex justify-start top-0 absolute right-0 ">
              <img
                className="xl:w-44 lg:w-40 md:w-32 w-20 xl:pt-0 lg:pt-0 md:pt-8 pt-16"
                src={clouds}
                alt=""
              />
            </div>

            <div className=" flex flex-wrap flex xl:px-0 px-4">
              <div className="xl:w-6/12 lg:w-6/12 md:w-6/12">
                {/* <p className="text-peach xl:text-3xl lg:text-3xl md:text-2xl bubblegum">
                  Welcome to Junior Toes
                </p> */}
                <h4 className="text-black xl:text-5xl text-2xl font-semibold  xl:pt-4 lg:pt-4 md:pt-4 pt-24 lg:text-4xl md:text-2xl">
                  Admission Open for AY
                  <span className="  text-blue">2025-2026</span>
                </h4>
                <p className="xl:text-xl text-xl xl:pt-6 lg:pt-6 md:pt-6 pt-4 text-blue font-semibold">
                  Introducing{" "}
                </p>
                <h4 className="text-black xl:text-4xl lg:text-4xl font-bold xl:mt-2 lg:mt-2 md:mt-2 -mt-2  md:text-2xl">
                  India's First
                  <span className="text-4xl">
                    <br></br>Entrepreneurial Preschool
                  </span>
                </h4>
                <div className="border-peach xl:w-3/12 lg:w-4/12 w-32 mt-4 xl:mt-4"></div>
                <p className="xl:text-2xl lg:text-2xl text-xl text-black xl:pt-4 pt-4">
                  Based on Antah Prerana-{" "}
                  <span className="text-peach">Way of Leaning</span>
                </p>
                <button
                  style={{ background: "#2d86a4" }}
                  className=" rounded text-white xl:text-base text-center px-4  py-2 xl:mt-4 mt-4"
                >
                  <a href="/contact">Contact Us</a>
                </button>
                <div className="xl:block lg:block md:hidden sm:hidden hidden">
                  <div className=" ">
                    <img
                      className="xl:w-44 w-32 lg:-ml-8  "
                      src={bfly1}
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 xl:mt-8 lg:mt-8 md:mt-4 mt-8">
                <div className="flex">
                  <div className="xl:w-4/12 lg:w-4/12 xl:block lg:hidden md:hidden hidden sm:hidden">
                    <img
                      className="xl:w-12/12 lg:w-12/12"
                      src={girlimg}
                      alt=""
                    />
                  </div>
                  <div className=" bg-white border-blue rounded-xl shadow-xl  xl:p-8 lg:p-4 p-4 xl:-ml-4 z-10">
                    {/* {formStatus === "success" && (
                      <div className="text-center text-green-500 sofia-pro">
                        Thank you for submitting the form!
                      </div>
                    )} */}

                    {/* Show Error Message */}
                    {formStatus === "error" && (
                      <div className="text-center text-red-500 sofia-pro">
                        There was an error submitting the form. Please try
                        again.
                      </div>
                    )}
                    <h1 className="xl:text-3xl lg:text-3xl md:text-2xl text-2xl text-black font-bold  text-center xl:pt-0 lg:pt-4 md:pt-0 pt-0 mb-8">
                      Enquire Now
                    </h1>
                    <form ref={form} onSubmit={sendEmail}>
                      <input
                        className="xl:w-12/12 w-12/12 rounded-lg borderform"
                        type="text"
                        id="text"
                        name="name"
                        placeholder="Child Name "
                        required
                      />
                      <input
                        className="xl:w-12/12 w-12/12 mt-4 xl:mt-6 rounded-lg borderform"
                        type="text"
                        id="text"
                        name="parentname"
                        placeholder="Parent Name"
                        required
                      />

                      <div className="flex flex-wrap  xl:mt-6 mt-4 items-center">
                        <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                          <input
                            className="xl:w-12/12 w-12/12 py-2 px-4 rounded-lg borderform"
                            type="text"
                            id="text"
                            name="email"
                            placeholder="Email"
                            required
                          />
                        </div>
                        <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 xl:mt-0 lg:mt-0 md:mt-0 mt-4">
                          <input
                            className="xl:w-12/12 w-12/12 rounded-lg borderform"
                            type="number"
                            id="number"
                            name="tel"
                            placeholder="Mobile Number"
                            required
                          />
                        </div>
                      </div>

                      <div className="flex flex-wrap xl:mt-6 mt-4 mb-4 items-center">
                        <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                          <select
                            className="xl:w-12/12 w-12/12  rounded-lg borderform"
                            id="academic"
                            name="branch"
                            placeholder=" Select Branch"
                            required
                          >
                            <option value="" disabled selected>
                              Select Branch
                            </option>
                            <option value="Malleshwaram">Malleshwaram</option>
                            <option value="RR Nagar">RR Nagar</option>
                            <option value="Hesaraghatta Road">
                              Hesaraghatta Road
                            </option>
                            <option value="RMV - Dollar Colony">
                              RMV - Dollar Colony
                            </option>
                            <option value="Rajajinagar"> Rajajinagar </option>
                            {/* <option value="Yelahanka">Yelahanka</option> */}
                            <option value="Acharya College Campus">
                              Acharya College Campus
                            </option>
                            <option value="Vijayanagar">Vijayanagar</option>
                            <option value="HSR Layout">HSR Layout</option>
                            <option value="Shubh Enclave - Haralur, Sarjapur">
                              Shubh Enclave - Haralur, Sarjapur
                            </option>
                            <option value="Indiranagar">Indiranagar</option>
                            <option value="Jayalakshmipuram - Mysore">Jayalakshmipuram - Mysore</option>
                            <option value="JP Nagar Metro Station">
                              JP Nagar Metro Station
                            </option>
                            <option value="Vidyaranyapura">
                              Vidyaranyapura
                            </option>
                            <option value="Mandya">Mandya</option>
                            <option value="Whitefield">Whitefield</option>
                            <option value="Nelamangala">Nelamangala</option>
                            <option value="Nagarbhavi">Nagarbhavi</option>
                            <option value="Rukmini Nagar HMT Layout">
                              Rukmini Nagar – HMT Layout
                            </option>
                            <option value="Jindal City Nagasandra">
                              Jindal City Nagasandra
                            </option>
                            <option value="Poornapragna Layout">
                              Poornapragna Layout
                            </option>
                            <option value="Hebbal Dasarahalli">
                              Hebbal Dasarahalli
                            </option>
                            <option value="Bharath Nagar">Bharath Nagar</option>
                            <option value="Banashankari 3rd Stage">
                              Banashankari 3rd Stage
                            </option>
                            <option value="Tumkur Adarshanagar">
                              Tumkur Adarshanagar
                            </option>
                            <option value="Sahakarnagar">Sahakarnagar</option>
                          </select>
                        </div>

                        <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 px-1 xl:mt-0 lg:mt-0 md:mt-0 mt-4">
                          <select
                            className="xl:w-12/12 w-12/12   rounded-lg borderform"
                            id="academic"
                            name="program"
                            placeholder=" Select a Program"
                            required
                          >
                            <option value="" disabled selected>
                              Select a Program
                            </option>

                            <option value="2-3 years: Sparklers (Playgroup)">
                              2-3 years: Sparklers (Playgroup)
                            </option>
                            <option value="3-4 years: Seekers (Nursery)">
                              3-4 years: Seekers (Nursery)
                            </option>
                            <option value="4-5 years: Pathfinders (Prep 1)">
                              4-5 years: Pathfinders (Prep 1)
                            </option>
                            <option value="* 5-6 years: Pioneers (Prep 2)">
                              5-6 years: Pioneers (Prep 2)
                            </option>
                          </select>
                        </div>
                      </div>
                      <ReCAPTCHA
                        sitekey="6Lff5xMsAAAAAI23wsM17cv64hBjF2Q7ZSlCYBee"
                        onChange={(token) => setCaptchaToken(token)}
                        className="w-12/12"
                      />

                      <div className="flex justify-center items-center gap-4 xl:mt-6 mt-4">
                        <input className="mt-1" type="checkbox" id="" />
                        <label
                          className="xl:text-sm lg:text-sm md:text-xs text-sm"
                          for=""
                        >
                          By clicking on Submit, I allow all communication from
                          Junior Toes
                        </label>
                      </div>

                      <div className="flex justify-center xl:mt-6 mt-6">
                        <button
                          className=" text-white rounded xl:px-8 xl:py-2 px-8 py-2"
                          style={{ background: "#2d86a4" }}
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* tab and mobile view */}
        <section
          className=" md:pt-32 pt-24 pb-12 md:pb-20 parkinsans bgh xl:hidden lg:hidden md:hidden sm:hidden hidden"
          style={{
            backgroundColor: "#f0f7fa",
            backgroundImage: `url(${bgg})`,
            backgroundPosition: "center center",
            backgroundRepeat: "repeat",
            backgroundSize: "55% auto",
          }}
        >
          <div className="px-4">
            <h4 className="text-black  font-semibold pt-4 md:text-4xl text-3xl">
              Admission Open for AY
              <span className="  text-blue"> 2025-2026</span>
            </h4>
            <p className="text-xl pt-6 text-blue font-semibold">Introducing </p>
            <h4 className="text-black md:text-4xl font-bold pt-2 text-2xl">
              India's First
              <span className="">
                <br></br>Entrepreneurial Preschool
              </span>
            </h4>
            <div className="border-peach w-36 mt-4"></div>
            <p className="md:text-2xl text-xl text-black pt-4">
              Based on Antah Prerana-{" "}
              <span className="text-peach">Way of Leaning</span>
            </p>
            <button
              style={{ background: "#2d86a4" }}
              className=" rounded text-white text-base text-center  py-2 px-8 mt-4"
            >
              <a href="/contact">Contact Us</a>
            </button>

            <div className="flex  mt-6">
              <div className="md:block sm:hidden hidden">
                <div className="md:w-6/12 w-6/12">
                  <img className="md:w-12/12  w-12/12" src={girlimg} alt="" />
                </div>
              </div>
              <div className=" bg-white border-blue rounded-xl shadow-xl  md:p-12 p-6 z-10 md:-ml-50 ">
                {/* {formStatus === "success" && (
                  <div className="text-center text-green-500 sofia-pro">
                    Thank you for submitting the form!
                  </div>
                )} */}

                {/* Show Error Message */}
                {formStatus === "error" && (
                  <div className="text-center text-red-500 sofia-pro">
                    There was an error submitting the form. Please try again.
                  </div>
                )}
                <h1 className=" md:text-3xl text-2xl text-black font-bold  text-center md:pt-0 pt-0 mb-8">
                  Enquire Now
                </h1>
                <form ref={form} onSubmit={sendEmail}>
                  <input
                    className=" w-12/12 rounded-lg borderform"
                    type="text"
                    id="text"
                    name="name"
                    placeholder="Full Name "
                    required
                  />
                  <input
                    className=" w-12/12 md:mt-6 mt-4  rounded-lg borderform"
                    type="text"
                    id="text"
                    name="parentname"
                    placeholder="Parent Name"
                    required
                  />
                  <div className="  md:mt-6 mt-4   gap-2">
                    <div className="">
                      <select
                        className=" w-12/12  rounded-lg borderform"
                        id="academic"
                        name="branch"
                        placeholder=" Select Branch"
                        required
                      >
                        <option value="" disabled selected>
                          Select Branch
                        </option>
                        <option value="Malleshwaram">Malleshwaram</option>
                        <option value="RR Nagar">RR Nagar</option>
                        <option value="Hesaraghatta Road">
                          Hesaraghatta Road
                        </option>
                        <option value="RMV - Dollar Colony">
                          RMV - Dollar Colony
                        </option>
                        <option value="Rajajinagar"> Rajajinagar </option>
                        {/* <option value="Yelahanka">Yelahanka</option> */}
                        <option value="Acharya College Campus">
                          Acharya College Campus
                        </option>
                        <option value="Vijayanagar">Vijayanagar</option>
                        <option value="HSR Layout">HSR Layout</option>
                        <option value="Shubh Enclave - Haralur, Sarjapur">
                          Shubh Enclave - Haralur, Sarjapur
                        </option>
                        <option value="Indiranagar">Indiranagar</option>
                        <option value="Jayalakshmipuram - Mysore">Jayalakshmipuram - Mysore</option>
                        <option value="JP Nagar Metro Station">
                          JP Nagar Metro Station
                        </option>
                        <option value="Vidyaranyapura">Vidyaranyapura</option>
                        <option value="Mandya">Mandya</option>
                        <option value="Whitefield">Whitefield</option>
                        <option value="Nelamangala">Nelamangala</option>
                        <option value="Nagarbhavi">Nagarbhavi</option>
                        <option value="Rukmini Nagar HMT Layout">
                          Rukmini Nagar – HMT Layout
                        </option>
                        <option value="Jindal City Nagasandra">
                          Jindal City Nagasandra
                        </option>
                        <option value="Poornapragna Layout">
                          Poornapragna Layout
                        </option>
                        <option value="Hebbal Dasarahalli">
                          Hebbal Dasarahalli
                        </option>
                        <option value="Bharath Nagar">Bharath Nagar</option>
                        <option value="Banashankari 3rd Stage">
                          Banashankari 3rd Stage
                        </option>
                        <option value="Tumkur Adarshanagar">
                          Tumkur Adarshanagar
                        </option>
                        <option value="Sahakarnagar">Sahakarnagar</option>
                      </select>
                    </div>

                    <div className=" md:mt-6 mt-4 ">
                      <select
                        className=" w-12/12   rounded-lg borderform"
                        id="academic"
                        name="program"
                        placeholder=" Select a Program"
                        required
                      >
                        <option value="" disabled selected>
                          Select a Program
                        </option>

                        <option value="2-3 years: Sparklers (Playgroup)">
                          2-3 years: Sparklers (Playgroup)
                        </option>
                        <option value="3-4 years: Seekers (Nursery)">
                          3-4 years: Seekers (Nursery)
                        </option>
                        <option value="4-5 years: Pathfinders (Prep 1)">
                          4-5 years: Pathfinders (Prep 1)
                        </option>
                        <option value="* 5-6 years: Pioneers (Prep 2)">
                          * 5-6 years: Pioneers (Prep 2)
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="   ">
                    <input
                      className=" w-12/12 md:mt-6 mt-4  rounded-lg borderform"
                      type="text"
                      id="text"
                      name="email"
                      placeholder="Email"
                      required
                    />
                    <input
                      className=" w-12/12 rounded-lg borderform md:mt-6 mt-4 "
                      type="number"
                      id="number"
                      name="tel"
                      placeholder="Mobile Number"
                      required
                    />
                  </div>
                  <ReCAPTCHA
                    sitekey="6Lff5xMsAAAAAI23wsM17cv64hBjF2Q7ZSlCYBee"
                    onChange={(token) => setCaptchaToken(token)}
                    className="w-12/12"
                  />

                  <div className="flex justify-center items-center gap-4  mt-4">
                    <input className="mt-1" type="checkbox" id="" />
                    <label className=" text-sm" for="">
                      By clicking on Submit, I allow all communication from
                      Junior Toes
                    </label>
                  </div>

                  <div className="flex justify-center  mt-6">
                    <button
                      className=" text-white rounded  px-8 py-2"
                      style={{ background: "#2d86a4" }}
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="xl:hidden lg:hidden md:block sm:block block">
            <div className="flex items-end">
              <img className="w-36 " src={bfly1} alt="" />
            </div>
          </div>
        </section>

        <section className=" bg-gray xl:py-12 lg:py-12 md:py-12 py-12 rounded-lg parkinsans xl:px-0 lg:px-4 md:px-4 xl:block lg:block md:hidden sm:hidden hidden">
          <div className="container mx-auto">
            <h1 className="xl:w-6/12 lg:w-8/12 md:w-10/12 mx-auto justify-center xl:text-4xl lg:text-4xl md:text-3xl  font-bold text-black text-center">
              Here is a step-by-step Admission Process for Junior Toes
            </h1>
            <p className="text-center text-blue xl:text-xl text-xl font-semibold xl:pt-2 pt-2">
              "Your child’s big dreams begin with the first step at Junior
              Toes."
            </p>

            <div className="flex gap-6 xl:mt-20 lg:mt-16 md:mt-16">
              <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 flex gap-4">
                <div className="xl:w-2/12 lg:w-2/12 md:w-2/12">
                  {/* <div className="rounded-lg flex justify-center items-center p-2" style={{ background: '#e0f4f9' }}> */}
                  <img src={one} alt="one"></img>
                  {/* </div> */}
                </div>
                <div className="xl:w-10/12 lg:w-10/12 md:w-10/12">
                  <h5 className="text-black font-bold xl:text-xl text-xl">
                    Submit the Application Form
                  </h5>
                  <p className="text-base xl:pt-3 pt-2">
                    Fill out the online or offline admission form available or
                    at the school reception. Ensure all required details are
                    accurately provided.
                  </p>
                </div>
              </div>

              <div className="xl:w-4/12 lg:w-4/12 flex gap-4">
                <div className="xl:w-2/12 lg:w-2/12">
                  {/* <div className="rounded-lg flex justify-center items-center p-2" style={{ background: '#fdf6d5' }}> */}
                  <img src={two} alt="two"></img>
                  {/* </div> */}
                </div>
                <div className="xl:w-10/12 lg:w-10/12 md:w-10/12">
                  <h5 className="text-black font-bold xl:text-xl text-xl">
                    Interaction Session
                  </h5>
                  <p className="text-base xl:pt-3 pt-2">
                    Attend an informal session with your child to meet our
                    facilitators, explore our teaching methods, and discuss your
                    child’s needs and interests
                  </p>
                </div>
              </div>

              <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 flex gap-4">
                <div className="xl:w-2/12 lg:w-2/12 md:w-2/12">
                  {/* <div className="rounded-lg flex justify-center items-center p-2" style={{ background: '#f4ddd9' }}> */}
                  <img src={three} alt="three"></img>
                  {/* </div> */}
                </div>
                <div className="xl:w-10/12 lg:w-10/12 md:w-10/12">
                  <h5 className="text-black font-bold xl:text-lg text-lg">
                    Confirmation of Admission
                  </h5>
                  <p className="text-base xl:pt-3 pt-2">
                    Once the application is reviewed, we will notify you of the
                    admission status. Upon selection, you will receive an
                    admission form and confirmation letter.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-6 xl:mt-20 lg:mt-16 md:mt-16 mx-auto justify-center">
              <div className="xl:w-4/12 lg:w-5/12 md:w-4/12 flex gap-4">
                <div className="xl:w-2/12 lg:w-2/12 md:w-2/12">
                  {/* <div className="rounded-lg flex justify-center items-center p-2" style={{ background: '#f9e9d7' }}> */}
                  <img src={four} alt="four"></img>
                  {/* </div> */}
                </div>
                <div className="xl:w-10/12 lg:w-12/12 md:w-10/12">
                  <h5 className="text-black font-bold xl:text-xl text-xl">
                    Complete the Formalities
                  </h5>
                  <p className="text-base xl:pt-3 pt-2">
                    Submit the required documents (birth certificate, medical
                    records, etc.) and complete the fee payment to secure your
                    child’s spot at Junior Toes.
                  </p>
                </div>
              </div>

              <div className="xl:w-4/12 lg:w-5/12 md:w-4/12 flex gap-4">
                <div className="xl:w-2/12 lg:w-1/12 md:w-2/12">
                  {/* <div className="rounded-lg flex justify-center items-center p-2" style={{ background: '#d1cfce' }}> */}
                  <img src={five} alt="five" className=""></img>
                  {/* </div> */}
                </div>
                <div className="xl:w-10/12 lg:w-10/12 md:w-10/12">
                  <h5 className="text-black font-bold xl:text-xl text-xl">
                    Welcome to Junior Toes!
                  </h5>
                  <p className="text-base xl:pt-3 pt-2">
                    Join us in shaping your little one’s journey of exploration,
                    learning, and growth. Let their first step into education be
                    truly extraordinary!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* tab view and mobile view */}
        <section className=" bg-gray  md:py-12 py-12 rounded-lg parkinsans  md:px-4 px-4 xl:hidden lg:hidden md:block sm:block block">
          <div className="container mx-auto">
            <h1 className=" md:w-10/12 mx-auto justify-center  md:text-3xl text-2xl  font-bold text-black text-center">
              Here is a step-by-step Admission Process for Junior Toes
            </h1>
            <p className="text-center text-blue xl:text-xl text-xl font-semibold  pt-2">
              "Your child’s big dreams begin with the first step at Junior
              Toes."
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 md:mt-12 mt-6 gap-6">
              <div>
                <div className=" flex gap-4">
                  <div className="">
                    <img src={one} alt="one"></img>
                  </div>
                  <div className="">
                    <h5 className="text-black font-bold  text-xl">
                      Submit the Application Form
                    </h5>
                    <p className="text-base  pt-2 ">
                      Fill out the online or offline admission form available or
                      at the school reception. Ensure all required details are
                      accurately provided.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className=" flex gap-4">
                  <div className="">
                    <img src={two} alt="one"></img>
                  </div>
                  <div className="">
                    <h5 className="text-black font-bold xl:text-xl text-xl">
                      Interaction Session
                    </h5>
                    <p className="text-base xl:pt-3 pt-2 ">
                      Attend an informal session with your child to meet our
                      facilitators, explore our teaching methods, and discuss
                      your child’s needs and interests
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className=" flex gap-4">
                  <div className="">
                    <img src={three} alt="one"></img>
                  </div>
                  <div className="">
                    <h5 className="text-black font-bold xl:text-xl text-xl">
                      Confirmation of Admission
                    </h5>
                    <p className="text-base xl:pt-3 pt-2 ">
                      Once the application is reviewed, we will notify you of
                      the admission status. Upon selection, you will receive an
                      admission form and confirmation letter.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className=" flex gap-4">
                  <div className="">
                    <img src={four} alt="one"></img>
                  </div>
                  <div className="">
                    <h5 className="text-black font-bold xl:text-xl text-xl">
                      Complete the Formalities
                    </h5>
                    <p className="text-base xl:pt-3 pt-2 ">
                      Submit the required documents (birth certificate, medical
                      records, etc.) and complete the fee payment to secure your
                      child’s spot at Junior Toes.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className=" flex gap-4">
                  <div className="">
                    <img src={five} alt="one"></img>
                  </div>
                  <div className="">
                    <h5 className="text-black font-bold xl:text-xl text-xl">
                      Welcome to Junior Toes!
                    </h5>
                    <p className="text-base xl:pt-3 pt-2 ">
                      Join us in shaping your little one’s journey of
                      exploration, learning, and growth. Let their first step
                      into education be truly extraordinary!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=" bg-gray xl:pt-12 lg:pt-12 lg:pb-16 md:pt-4 md:pb-16 xl:pb-24 xl:px-0 px-4">
          <div className="xl:px-24 ">
            <div className=" bgh container mx-auto rounded-xl xl:px-6 xl:py-6 lg:py-6 md:py-6 py-4 px-4">
              <div className="flex flex-wrap items-center justify-between gap-6 xl:pl-0 lg:pl-4 md:pl-4 pl-4">
                <div className="flex items-center gap-4 xl:w-5/12 lg:w-5/12 md:w-4/12">
                  <div className="xl:w-3/12 lg:w-3/12 md:w-4/12">
                    <img
                      className="xl:w-12/12 lg:w-12/12 md:w-12/12 w-8/12"
                      src={school}
                      alt=""
                    />
                  </div>
                  <div className="xl:pl-6">
                    <h1 className="text-blue font-bold text-xl">
                      Fees & Tuition:
                    </h1>
                    <p className="text-base text-black font-semibold">
                      A visit to meet our counsellor will help you understand
                      the fee structure .
                    </p>
                  </div>
                </div>

                <div className="xl:w-5/12 flex gap-4">
                  <div>
                    <p className="xl:text-xl text-xl text-black font-semibold  pt-4">
                      Monday to Friday
                    </p>
                    <p className="xl:text-lg text-lg text-blue pt-1 font-semibold">
                      9.00 AM TO 4.00 PM
                    </p>
                  </div>

                  <div className="center-button xl:w-2/12">
                    <img className="w-2 xl:mt-4" src={zigzag} alt="" />
                  </div>

                  <div>
                    <p className="xl:text-xl text-xl text-black font-semibold pt-4">
                      Saturday
                    </p>
                    <p className="xl:text-lg text-lg text-blue pt-1 font-semibold">
                      9.00 AM TO 1.00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer2 />
    </>
  );
}
